import { CopilotPanelContentBase, CopilotPanelContext } from 'models/copilot/copilotBridge';

export class CopilotLibrarySelectedDocument {
  libraryLinkId: number;

  libraryListId: number;

  title: string;

  mimeType: string;

  constructor(libraryLinkId: number, libraryListId: number, title: string, mimeType: string) {
    this.libraryLinkId = libraryLinkId;
    this.libraryListId = libraryListId;
    this.title = title;
    this.mimeType = mimeType;
  }
}

export class CopilotLibraryContent extends CopilotPanelContentBase {
  public readonly context = CopilotPanelContext.Library;

  selectedDocument?: CopilotLibrarySelectedDocument;

  constructor() {
    super();
  }

  setSelectedDocument(selectedDocument: CopilotLibrarySelectedDocument | undefined): void {
    this.selectedDocument = selectedDocument;
  }
}
